/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) File Icon component.
 */
export const FileIcon = ({color, size, ...props}: IconProps) => {
  const {iconSize = 24, iconColor=dlsColor('grey1')} = useIconDLS({color, size});
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
      <path d='M14 3V8C14 8 17.0474 8 19 8M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2Z' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
    
  );
};
